/**
 * Konfiguration für den Sonnen-Lebenszyklus.
 * Zeitangaben in Echtzeit. Die Lebensdauer (3–5 Monate) ist die
 * Basis-Zeiteinheit für das gesamte Spiel (Ressourcen, Gebäude, etc.).
 */

export interface SunLifecycleConfig {
  /** Minimale Lebensdauer in Echtzeit-Tagen. */
  readonly minDays: number;
  /** Maximale Lebensdauer in Echtzeit-Tagen. */
  readonly maxDays: number;
  /** Sekunden vor Zerstörung: ALIVE → IMPLODING. */
  readonly implodeThresholdSec: number;
  /** Sekunden vor Zerstörung: IMPLODING → EXPLODING/COLLAPSING. */
  readonly deathThresholdSec: number;
  /** Chance (0–1) dass eine sterbende Sonne ein Schwarzes Loch wird. */
  readonly blackHoleChance: number;
}

export function defaultSunLifecycleConfig(): SunLifecycleConfig {
  return {
    minDays: 90,
    maxDays: 150,
    implodeThresholdSec: 8,
    deathThresholdSec: 3,
    blackHoleChance: 0.3,
  };
}
